import type { ButtonHTMLAttributes } from "react";
import { colors, radius } from "../tokens";

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "secondary";
}

export function Button({ variant = "primary", style, ...props }: ButtonProps) {
  const isPrimary = variant === "primary";
  return (
    <button
      {...props}
      style={{
        background: isPrimary ? colors.navy : "#fff",
        color: isPrimary ? "#fff" : colors.text,
        border: isPrimary ? "none" : `1.5px solid ${colors.border}`,
        borderRadius: radius.md,
        minHeight: 46,
        padding: "0 18px",
        fontSize: 14,
        fontWeight: 800,
        cursor: "pointer",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 8,
        whiteSpace: "nowrap",
        ...style,
      }}
    />
  );
}
